module.exports = __webpack_public_path__ + "img/AssetsBranding-02UNIR.e00f2ac8.png";